import { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";

export function OfflineBanner() {
  const [online, setOnline] = useState(typeof navigator === "undefined" ? true : navigator.onLine);

  useEffect(() => {
    const up = () => setOnline(true);
    const down = () => setOnline(false);
    window.addEventListener("online", up);
    window.addEventListener("offline", down);
    return () => {
      window.removeEventListener("online", up);
      window.removeEventListener("offline", down);
    };
  }, []);

  if (online) return null;
  return (
    <div
      role="alert"
      className="bg-red-50 border border-red-200 text-red-800 px-4 py-2 rounded-sm flex items-center gap-2 text-sm mb-3"
      data-testid="pos-offline-banner"
    >
      <WifiOff className="w-4 h-4" aria-hidden="true" />
      <span>Mất kết nối — thao tác có thể không lưu được. Đợi mạng trở lại.</span>
    </div>
  );
}
